import React, { useMemo, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { CategoriesOrder as View } from '@views';
import { LOADING, SUCCESS, FAILURE } from '@constants/requestPhase';
import { getCategories } from '@helpers/categoryEdit';
import { submitCategoriesOrder } from '@store/menu/duck';
import { routes } from '@constants';

const CategoriesOrder = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const categoryId = location.state ? location.state.id : 0;

  const { categories, submitCategoriesOrderPhase } = useSelector(state => state.menu);

  const memoizedCategories = useMemo(() => (
    getCategories(categories)
  ), [categoryId]);

  const [sortedCategories, setSortedCategories] = useState(memoizedCategories);
  const [hasServerError, setHasServerError] = useState(false);

  const categoriesOrder = sortedCategories.map(category => parseInt(category.id, 10));

  const handleToastClose = () => {
    setHasServerError(false);
  };

  const handleEditCancel = () => {
    history.goBack();
  };

  const handleDragCategoryEnd = ({ destination, source }) => {
    if (destination && destination.index !== source.index) {
      const reorderedCategories = [...sortedCategories];
      reorderedCategories.splice(source.index, 1);
      reorderedCategories.splice(destination.index, 0, sortedCategories[source.index]);
      setSortedCategories(reorderedCategories);
    }
  };

  const handleEditSubmit = () => {
    dispatch(submitCategoriesOrder({
      categoryIds: categoriesOrder,
    }));
  };

  useEffect(() => {
    if (submitCategoriesOrderPhase === SUCCESS) {
      history.push(routes.menu);
    }
    if (submitCategoriesOrderPhase === FAILURE) {
      setHasServerError(true);
    }
  }, [submitCategoriesOrderPhase]);

  const isConfirmButtonDisabled = JSON.stringify(categoriesOrder) === JSON.stringify(categories.sortedIds);

  return (
    <View
      isConfirmButtonDisabled={isConfirmButtonDisabled}
      isLoading={LOADING === submitCategoriesOrderPhase}
      onDragCategoryEnd={handleDragCategoryEnd}
      onEditCancel={handleEditCancel}
      categories={sortedCategories}
      onToastClose={handleToastClose}
      hasServerError={hasServerError}
      onEditSubmit={handleEditSubmit}
    />
  );
};

export default CategoriesOrder;
